import { IntlShape } from 'react-intl';
import { Feature, getFeatureFromPlan, isTrueBundleFeature, OrderItem } from '../../models';

/**
 * The product name of an order item, as Order details names it. `productName` is the Recurly plan
 * name the BE stored with the order ("TestOps (per-User)", "Katalon True Platform" before the True
 * Manual rename), so it is the last resort for an SKU without a translation (#1287).
 */
export const getOrderItemDisplayName = (
  intl: IntlShape,
  orderItem: OrderItem,
  features: { feature: Feature; planName: string }[],
) => {
  const feature = getFeatureFromPlan(orderItem.planId ?? '');
  // A True Bundle is named per channel by the BE ("True Manual Starter" online vs "True Manual"
  // direct) and both channels share one feature, so the stored name wins.
  if (feature && !isTrueBundleFeature(feature)) {
    const featureConfig = features.find(f => f.feature === feature);
    if (featureConfig) {
      return intl.formatMessage({ id: featureConfig.planName });
    }
    const productNameKey = `feature.${feature.toLowerCase()}.product.name`;
    if (intl.messages[productNameKey]) {
      return intl.formatMessage({ id: productNameKey });
    }
  }
  return orderItem.productName || orderItem.planId || 'Product';
};
